import CardForm from "../../components/form/CardForm";
import FontInventoryInfoFormConfig from "./FontInventoryInfoFornConfig";
import React from "react";
import { useTranslation } from 'react-i18next';

export function InventoryDetails(props) {
    const { t } = useTranslation();
    
    return <>
        {props.inventory &&
            <CardForm
                title={t("forms.inventory_details")}
                setLoader={props.loader}
                initialData={props.inventory}
                fields={FontInventoryInfoFormConfig}
                width={6}
                readOnly={true}
            />
        }
    </>;
}